module.exports = __webpack_public_path__ + "fonts/be-vietnam-pro-v8-latin-800.e067b00.woff2";